module.exports = __webpack_public_path__ + "static/media/aankoop.b0a7f0d8.svg";